import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import "./Auth.css";
import { toast } from "react-toastify";

function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();

  // Hooks
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const email = location.state?.email;

  if (!email) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Invalid Access</h2>
          <p className="auth-subtitle">
            Please request password reset again.
          </p>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axiosInstance.post("/accounts/reset-password/", {
        email,
        otp,
        new_password: password,
      });

      toast.success("Password reset successful");
      navigate("/login");
    } catch (error) {
      const message =
        error.response?.data?.non_field_errors?.[0] ||
        error.response?.data?.detail ||
        "Invalid OTP or expired";

      toast.error(message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Reset Password</h2>
        <p className="auth-subtitle">
          Enter OTP and create a new password
        </p>

        <form onSubmit={handleSubmit}>
          {/* OTP */}
          <div className="input-group">
            <input
              required
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <label>OTP</label>
            <span className="input-line"></span>
          </div>

          {/* New Password */}
          <div className="input-group">
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label>New Password</label>
            <span className="input-line"></span>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
